import { BarChart3 } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const ixinaDashboardManifest: ModuleDefinition = {
  id: 'ixina-dashboard',
  name: 'Smart Dashboard',
  icon: <BarChart3 size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/dashboard',
  status: 'active',
  navItems: [
    { label: 'Cockpit', path: '/dashboard/cockpit', icon: '' },
    { label: 'Cijfers', path: '/dashboard/overzicht', icon: '' },
    { label: 'Verkopers', path: '/dashboard/verkopers', icon: '' },
    { label: 'Plaatsers', path: '/dashboard/plaatsers', icon: '' },
    { label: 'Geografie', path: '/dashboard/geografie', icon: '' },
    { label: 'Orderboek', path: '/dashboard/orderboek', icon: '' },
    { label: 'Weekstart', path: '/dashboard/weekstart', icon: '' },
    { label: 'Maandstart', path: '/dashboard/maandstart', icon: '' },
    { label: 'Fronten', path: '/dashboard/fronten', icon: '', menu: 'meer' },
    { label: 'Bonussen', path: '/dashboard/bonussen', icon: '', menu: 'meer' },
    { label: 'Import', path: '/dashboard/import', icon: '', menu: 'meer' },
    { label: 'Portfolio', path: '/dashboard/portfolio', icon: '', menu: 'meer' },
    { label: 'Doelen', path: '/dashboard/doelen', icon: '', menu: 'meer' },
    { label: 'Rapportages', path: '/dashboard/rapportages', icon: '', menu: 'meer' },
    { label: 'Winkels', path: '/dashboard/entities', icon: '', menu: 'meer' },
    { label: 'Monitor', path: '/dashboard/monitor', icon: '', menu: 'meer' },
    { label: 'Benchmark', path: '/dashboard/benchmark', icon: '', menu: 'meer' },
    { label: 'Health', path: '/dashboard/health', icon: '', menu: 'meer' },
    { label: 'Builder', path: '/dashboard/builder', icon: '', menu: 'meer' },
    { label: 'Admin', path: '/dashboard/superadmin', icon: '', menu: 'meer' },
    { label: 'Config', path: '/dashboard/system-config', icon: '', menu: 'meer' },
    { label: 'Login als', path: '/dashboard/impersonate', icon: '', menu: 'meer' },
  ],
  component: () => import('./index.js'),
};

export default ixinaDashboardManifest;
